import React, { useEffect, useState } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';

function CustomNavbar() {
  const [expanded, setExpanded] = useState(false);
  const [activeSection, setActiveSection] = useState('#home');

  const handleNavClick = () => {
    setExpanded(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['#home', '#about', '#goals', '#choose', '#culture', '#work', '#contact'];
      let currentSection = '#home';

      sections.forEach((id) => {
        const section = document.querySelector(id);
        if (section) {
          const rect = section.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            currentSection = id;
          }
        }
      });

      setActiveSection(currentSection);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // run once on mount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
 
  // const [color, setColor] = useState(false);
  // useEffect(() => {
  //   const changeColor = () => {
  //     if (window.scrollY >= 90) {
  //       setColor(true);
  //     } else {
  //       setColor(false);
  //     }
  //   };

  //   window.addEventListener('scroll', changeColor);

  //   changeColor();
  //   return () => {
  //     window.removeEventListener('scroll', changeColor);
  //   };
  // }, []);

  return (
    <Navbar
      expand="lg"
      className='navbar-bg'
      variant="dark"
      fixed='top'
      expanded={expanded}
      onToggle={() => setExpanded(!expanded)}
    >
      <Container>
        <Navbar.Brand href="#home" className="nav-brand">Matrimony</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" className='navbar-toggle' />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto" id="navbar-example" activeKey={activeSection}>
            
            <Nav.Link href="#about" onClick={handleNavClick}>About</Nav.Link>
            <Nav.Link href="#goals" onClick={handleNavClick}>Goals</Nav.Link>
            <Nav.Link href="#choose" onClick={handleNavClick}>Why Us</Nav.Link>
            <Nav.Link href="#culture" onClick={handleNavClick}>Culture</Nav.Link>
            <Nav.Link href="#work" onClick={handleNavClick}>Process</Nav.Link>
            <Nav.Link href="#contact" onClick={handleNavClick}>Contact</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default CustomNavbar;
